import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantsUtil } from './core/utils/constants.util';
import { ApplicationInsightsService } from './core/services/application-insights.service';
import { ThemeSwitchService } from './core/services/theme/theme-switch.service';
import { ThemeEnabledOptions } from './core/models/Theme.enum';
import { MsalService } from '@azure/msal-angular';
import { MvMsalService } from '@aot/host-app-widgets-demo';

import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = ConstantsUtil.constants.OH_ENTITY_VIEWER_TEMPLATE_UPLOAD_UI;
  public authInitialized = false;
  private scope: string[] = [
    `${window.environmentVariableConfig.accentureADConfig.clientId}/access_as_user`,
];

  constructor(
    public router: Router,
    private readonly applicationInsightsService: ApplicationInsightsService,
    private readonly themeSwithService: ThemeSwitchService, private authService: MsalService, 
    private mvMsalService : MvMsalService
  ) {
    this.themeSwithService.initializeAppTheme();
  }

  public ngOnInit(): void {

    localStorage.setItem('showSwitchThemeOption', ThemeEnabledOptions.YES);
    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult | null) => {
        if (result) {
          this.mvMsalService.userAuthenticated(result);
        }else {
          // Check for active account on page refresh
          const activeAccount = this.authService.instance.getActiveAccount();
          if (activeAccount) {
            if(this.mvMsalService['isTokenExpired']()){
              this.authService.acquireTokenSilent({
                account: activeAccount,
                scopes: this.scope,
                forceRefresh: true
              }).subscribe({
                next: (freshResult: AuthenticationResult) => {
                  this.mvMsalService.userAuthenticated(freshResult);
                },
                error: (error) => {
                  console.error("Silent token acquisition failed", error);
                  this.authService.loginRedirect(); // fallback to interactive login
                }
              });
            }else{
              this.mvMsalService.userAuthenticated({account: activeAccount} as AuthenticationResult);
            }
             
          } else {
              // Handle unauthenticated state
              console.log("User is not authenticated.");
              this.navigatetoLogin();
              // Redirect to login or show login button
          }
      }
        this.authInitialized = true;
      },
      error: (error) => {console.error(error);
          this.authInitialized = true;}
    });
    window.addEventListener(ConstantsUtil.events.NAVIGATE_TO_LOGIN, (evt) => {
      this.navigatetoLogin()
    });

    window.addEventListener(ConstantsUtil.events.TO_HOME, (evt) => {
      this.navigatetoHome()
    });

    window.addEventListener(ConstantsUtil.events.TO_GLOBE, (evt) => {
      this.navigatetoHome()
    });
    
  } 

  private navigatetoHome(): void{
    this.router.navigateByUrl(ConstantsUtil.routes.SLASH_HOME);
  }

  private navigatetoLogin(): void {
    this.router.navigateByUrl(ConstantsUtil.routes.SLASH_LOGIN);
  }
}
